import React, { useState } from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { useBenefits } from '../BenefitsProvider'
import { Modal, Stack } from '~/components/_layouts'
import { UserIcon } from '@heroicons/react/24/outline'
import parse from 'html-react-parser'
import { Button } from '~/lib/ui/button'
import { cn } from '~/lib/utils'

const FeedbackDialog = () => {
  const { showFeedbackDialog, toggleShowFeedbackDialog, feedbackContent } =
    useBenefits()
  const { t } = useTranslation()

  return (
    <Modal
      title={
        <Stack direction="row" spacing={2}>
          <UserIcon className="h-6 w-6" />
          {t('feedback_modal.title')}
        </Stack>
      }
      variant="secondary"
      size="md"
      open={showFeedbackDialog}
      onClose={() => toggleShowFeedbackDialog()}
    >
      {feedbackContent}
    </Modal>
  )
}

export default FeedbackDialog

export const ReactFeedbackDialog = ({ requestType, children }) => {
  const { serviceRequestList, current_user } = useBenefits()
  const { t } = useTranslation('feedback_modal')

  const [showDialog, setShowDialog] = useState(false)

  const selectedRequest = serviceRequestList[requestType]

  const downloadUrl = !!selectedRequest?.uploaded_document?.url

  const type = requestType?.split('::')[1]
  const typeMap = {
    JobSearchStrategy: t('JobSearchStrategy'),
    InterviewPrep: t('InterviewPrep'),
    JobSearchBurnout: t('AvoidingBurnout'),
    CareerPivotPlanning: t('CareerPivotPlanning'),
  }
  const typeName = typeMap[type]

  const toggleShowDialog = () => {
    setShowDialog(!showDialog)
  }

  if (!showDialog) {
    return <div onClick={() => setShowDialog(true)}>{children}</div>
  }

  const completedAt = new Date(
    selectedRequest?.completed_at,
  ).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
  })

  return (
    <Modal
      variant="secondary"
      size="md"
      open={showDialog}
      onClose={toggleShowDialog}
      title={
        <Stack direction="row" spacing={2}>
          <UserIcon className="h-6 w-6" />
          {t('title')}
        </Stack>
      }
    >
      <div className="flex flex-col">
        <div>{t('header', { typeName })}</div>
        <GridRow className={'pt-4'}>
          <div>{t('name')}</div>
          <div>{current_user.candidate_name}</div>
        </GridRow>
        <GridRow className={'border-t border-[#B9B9B9] pt-4'}>
          <div>{t('created_at')}</div>
          <div>{completedAt}</div>
        </GridRow>
        <div className="border-t border-[#B9B9B9] pt-4">
          <div>{t('message')}</div>
        </div>
        <div className="border border-[#B9B9B9] p-4">
          {selectedRequest?.message}
        </div>
        <div className="mt-8 border-t border-[#B9B9B9] pt-4">
          <div>{t('feedback')}</div>
        </div>
        <div className="border border-[#B9B9B9] p-4">
          {parse(selectedRequest?.coach_message)}
        </div>
      </div>
      {downloadUrl && (
        <a href={selectedRequest.uploaded_document.url}>
          <Button variant="coachcta">{t('download')}</Button>
        </a>
      )}
    </Modal>
  )
}

const GridRow = ({ className, children }) => {
  return <div className={cn('flex justify-between', className)}>{children}</div>
}
